import { Component, ErrorInfo, ReactNode } from "react";
import { reportError } from "../../services/errorReporting";

interface ErrorBoundaryClassProps {
  children: ReactNode;
  fallback: ReactNode;
}

interface ErrorBoundaryClassState {
  hasError: boolean;
}

// Plain class component: React error boundaries can only be implemented as a
// class (getDerivedStateFromError/componentDidCatch have no hook equivalent).
// Kept separate from ErrorBoundary.tsx so that one can use hooks (useTranslation)
// for the fallback UI without fighting that constraint.
export class ErrorBoundaryClass extends Component<
  ErrorBoundaryClassProps,
  ErrorBoundaryClassState
> {
  constructor(props: ErrorBoundaryClassProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryClassState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    reportError(error, { componentStack: errorInfo.componentStack });
  }

  render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}
